import DataDriven from "@modules/common/icons/data-driven";
import PillBubble from "./PillBubble";
import Profitable from "@modules/common/icons/profitable";
import Clock from "@modules/common/icons/clock";
import Gear from "@modules/common/icons/gear";
import GearStar from "@modules/common/icons/gear-star";

function Statement({
  data,
}: {
  data: {
    statementProfitableText: string;
    statementDataDriventext: string;
    statementPerfectMomentText: string;
    statementWithoutManualWorkText: string;
    statementSpotlighText: string;
  };
}) {
  return (
    <div className="w-full px-4 sm:px-24 sm:text-4xl !leading-loose text-darkGreen text-center tracking-wider">
      Empower your business with
      <PillBubble
        text="profitable"
        description={data.statementProfitableText}
        Icon={Profitable}
      />
      , personalized,
      <PillBubble
        text="data-driven"
        description={data.statementDataDriventext}
        Icon={DataDriven}
      />
      loyalty. Ensure the right reward reaches the right customer at the
      <PillBubble
        text="perfect moment"
        description={data.statementPerfectMomentText}
        Icon={Clock}
      />
      -
      <PillBubble
        text="without the manual work"
        description={data.statementWithoutManualWorkText}
        Icon={Gear}
      />
      . We help you stay consistently engaged with your customers. Through
      automated reminders and strategic touchpoints, your brand will always be
      in the
      <PillBubble
        text="spotlight"
        description={data.statementSpotlighText}
        Icon={GearStar}
      />
      .
    </div>
  );
}

export default Statement;
